import { useEffect } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useParams } from "react-router";
import {
  fetchAmberPlusCrossPageDataIfNeeded,
  setAmberPlusCrossMeta,
  fetchStandardKitData,
} from "./data/amberPlusCrossReducer";

const useAmberPlusCross = () => {
  const dispatch = useDispatch();
  const { service: slug } = useParams<{ service?: string }>();

  const { isError, isStatus500 } = useSelector((state: any) => {
    const status = state.amberPlusCrossPageData?.readyStatus;
    // Only block rendering with an error page when:
    // - The fetch has failed (status === "failure"), AND
    // - We are on the server (SSR), where there's no retry useEffect.
    // On the client, a "failure" state immediately triggers a retry via the
    // useEffect below (shouldFetchPage now allows retries on failure), so
    // we suppress the error page to avoid a flash of the 500 screen before
    // the retry resolves. The page renders with whatever data is in the store.
    const hasFailed = status === "failure" && !__CLIENT__;
    const isStatus500Val = !JSON.stringify(state.amberPlusCrossPageData?.error)?.includes("404");
    return { isError: hasFailed, isStatus500: isStatus500Val };
  }, shallowEqual);

  useEffect(() => {
    dispatch(fetchAmberPlusCrossPageDataIfNeeded());
    // fetchStandardKitData is SSR-only in loadData, so always refresh it
    // on the client — covers back-navigation from /essential-kit/* where
    // the store still holds the server-hydrated value from first load.
    if (__CLIENT__) dispatch(fetchStandardKitData());
  }, [dispatch]);

  useEffect(() => {
    const url = typeof window !== "undefined" ? window.location.href : null;
    dispatch(setAmberPlusCrossMeta(slug, url));
  }, [dispatch, slug]);

  return { isError, isStatus500 };
};

export default useAmberPlusCross;
